
import { styled } from '@mui/material/styles';
import { Box, ListItemButton, TableContainer, TableHead, TableRow, Typography, Button } from '@mui/material';

// The main white card container for the entire page content
export const MainContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  padding: theme.spacing(3),
  width: '100%',
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: '#666',
  marginBottom: theme.spacing(3),
  fontSize: '0.9rem',
}));

export const LayoutGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

// Left Panel - Facility Types List (Bordered Box, not Paper)
export const FacilityTypesPanel = styled(Box)(({ theme }) => ({
  width: '250px',
  minWidth: '250px',
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  padding: theme.spacing(3),
  height: 'fit-content',
}));

export const FacilityTypesTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  marginBottom: theme.spacing(2),
  color: '#333',
}));

export const FacilityTypeItem = styled(ListItemButton)<{ selected?: boolean }>(({ theme, selected }) => ({
  borderRadius: '4px',
  marginBottom: theme.spacing(1),
  backgroundColor: selected ? '#E8F5E9' : 'transparent', // Light green for selected
  '&:hover': {
    backgroundColor: selected ? '#E8F5E9' : '#f5f5f5',
  },
  '& .MuiTypography-root': {
    fontWeight: selected ? 600 : 400,
    color: '#333',
  }
}));

// Right Panel - Document Mapping Table (Bordered Box, not Paper)
export const MappingPanel = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  borderRadius: '8px',
  border: '1px solid #E0E0E0',
  padding: theme.spacing(3),
}));

export const MappingTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  marginBottom: theme.spacing(2),
  color: '#333',
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  // No additional styling needed as border is on parent panel
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    backgroundColor: '#5E8E7E',
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.875rem',
    padding: '8px 16px', // Reduced height
    height: '40px', // Explicit height constraint
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#FAFAFA',
  },
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  backgroundColor: '#5E8E7E',
  color: '#fff',
  fontWeight: 600,
  padding: '8px 32px',
  marginTop: theme.spacing(3),
  float: 'right',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  }
}));
